import { Component, OnInit, ViewChild } from '@angular/core';
import { EventService } from './services/event.service';
import { MatSidenav } from '@angular/material/sidenav';
import { environment } from '../environments/environment';
import { QuestDisplayType } from '../../../quest/src/lib/quest-display-type.enum';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DisplaytypesComponent } from './displaytypes/displaytypes.component';
import { MatButtonToggleChange } from '@angular/material/button-toggle';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    title = 'quest-lib-app';

    public showSettings: boolean;

    public backend: string;
    public displayType: QuestDisplayType;
    public model: string;
    public application: string;
    public lang: string;

    @ViewChild('drawer') sidenav: MatSidenav;

    constructor(public router: Router, private eventService: EventService, private translate: TranslateService) {}

    ngOnInit(): void {
        const parameters = new URLSearchParams(window.location.search);

        this.backend = parameters.get('backend') || 'model';
        this.lang = parameters.get('lang') || environment.defaultLanguage;
        this.displayType =
            <QuestDisplayType>parameters.get('displayMode') || environment.quest.configurationDisplayType;
        this.application = parameters.get('application') || 'quote-assist';
        this.model = parameters.get('model') || environment.quest.defaultModel;

        this.translate.setDefaultLang(this.lang);
    }

    public onActivate(componentRef) {
        this.showSettings = componentRef instanceof DisplaytypesComponent;
    }

    emitViewChange(displayType: string) {
        this.eventService.emitParamChange({ displayMode: displayType });
    }

    emitLangChange(lang: string) {
        this.eventService.emitParamChange({ lang: lang });
    }

    emitModelChange(modelId: string) {
        this.eventService.emitParamChange({ model: modelId });
    }

    emitBackendChange(event: MatButtonToggleChange) {
        this.eventService.emitParamChange({ backend: event.value });
    }

    emitApplicationChange(application: string) {
        this.eventService.emitParamChange({ application });
    }
}
